import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { ContentProvider } from "./context/ContentContext";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import OwnerDashboard from "./pages/OwnerDashboard";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function App() {
  return (
    <LanguageProvider>
      <ContentProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/owner" element={<OwnerDashboard />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </LanguageProvider>
  );
}

export default App;
